import { render, staticRenderFns } from "./EditOutBound.vue?vue&type=template&id=f84fc50a&scoped=true&"
import script from "./EditOutBound.vue?vue&type=script&lang=js&"
export * from "./EditOutBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84fc50a",
  null
  
)

export default component.exports